import { DatePicker, Form, Radio, Switch } from "antd";
import moment from "moment";

import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";

import { DatevExportValues, SKR } from "./types";

export const initialDatevExportValues: Partial<DatevExportValues> = {
  skr: SKR.SKR03,
  date: moment(),
  withReceipts: false,
};

const getTexts = (t: TFunction) => {
  const keyPrefix = "command.datevExport";
  return {
    skr: {
      label: t(`${keyPrefix}.skr.label`),
      optionLabels: {
        [SKR.SKR03]: t(`${keyPrefix}.skr.optionLabels.SKR03`),
        [SKR.SKR04]: t(`${keyPrefix}.skr.optionLabels.SKR04`),
      },
    },
    date: {
      label: t(`${keyPrefix}.date.label`),
      placeholder: t(`${keyPrefix}.date.placeholder`),
    },
    withReceipts: {
      label: t(`${keyPrefix}.withReceipts.label`),
      yes: t(`${keyPrefix}.withReceipts.yes`),
      no: t(`${keyPrefix}.withReceipts.no`),
    },
  };
};

export const DatevExport = () => {
  const { t } = useTranslation("CommandHub");
  const texts = getTexts(t);
  return (
    <>
      <Form.Item label={texts.skr.label} name="skr" className="mt-4">
        <Radio.Group
          options={Object.values(SKR).map((skr) => ({
            label: texts.skr.optionLabels[skr],
            value: skr,
          }))}
        />
      </Form.Item>
      <Form.Item label={texts.date.label} name="date">
        <DatePicker
          placeholder={texts.date.placeholder}
          picker="year"
          disabledDate={(date) => date?.year() > moment().year()}
        />
      </Form.Item>

      <Form.Item label={texts.withReceipts.label} name="withReceipts">
        <Switch
          checkedChildren={texts.withReceipts.yes}
          unCheckedChildren={texts.withReceipts.no}
        />
      </Form.Item>
    </>
  );
};
